import { render } from "./Writing.vue?vue&type=template&id=19c38a51&scoped=true"
import script from "./Writing.vue?vue&type=script&lang=js"
export * from "./Writing.vue?vue&type=script&lang=js"

import "./Writing.vue?vue&type=style&index=0&id=19c38a51&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19c38a51"]])

export default __exports__